<p-tabView
  class="m-tabview"
  [scrollable]="scrollable"
  [styleClass]="styleClass"
  [style]="style"
  [ngClass]="{ 'tabs-with-divider': showDivider && tabPanelHeaders.length > 1 }"
  [(activeIndex)]="activeIndex"
  (activeIndexChange)="emitIndexChange()">
  @for (tabPanel of tabPanelHeaders; track tabPanel; let i = $index) {
    <p-tabPanel [disabled]="tabPanel?.disabled ?? false">
      <ng-template pTemplate="header">
        <div class="flex items-center gap-2">
          <span
            [ngClass]="{
              dp2: headerSize === 'default',
              sh2: headerSize === 'small',
            }"
            class="font-normal"
            >{{ tabPanel.header }}</span
          >
          @if (tabPanel.showCount) {
            <span class="bg-gray-200 text-gray-800 b2 rounded-full px-3">{{
              tabPanel.count
            }}</span>
          }
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <ng-template [ngTemplateOutlet]="tabContentList[i]"></ng-template>
      </ng-template>
    </p-tabPanel>
  }
</p-tabView>
